/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardScheme } from './CardScheme';
import {
    CardSchemeFromJSON,
    CardSchemeFromJSONTyped,
    CardSchemeToJSON,
    CardSchemeToJSONTyped,
} from './CardScheme';

/**
 * 
 * @export
 * @interface CardSchemePriceOverride
 */
export interface CardSchemePriceOverride {
    /**
     * 
     * @type {CardScheme}
     * @memberof CardSchemePriceOverride
     */
    cardScheme: CardScheme;
    /**
     * 
     * @type {number}
     * @memberof CardSchemePriceOverride
     */
    fixedFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CardSchemePriceOverride
     */
    variableFeePercentage: number;
}



/**
 * Check if a given object implements the CardSchemePriceOverride interface.
 */
export function instanceOfCardSchemePriceOverride(value: object): value is CardSchemePriceOverride {
    if (!('cardScheme' in value) || value['cardScheme'] === undefined) return false;
    if (!('fixedFeeAmount' in value) || value['fixedFeeAmount'] === undefined) return false;
    if (!('variableFeePercentage' in value) || value['variableFeePercentage'] === undefined) return false;
    return true;
}

export function CardSchemePriceOverrideFromJSON(json: any): CardSchemePriceOverride {
    return CardSchemePriceOverrideFromJSONTyped(json, false);
}

export function CardSchemePriceOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardSchemePriceOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'cardScheme': CardSchemeFromJSON(json['cardScheme']),
        'fixedFeeAmount': json['fixedFeeAmount'],
        'variableFeePercentage': json['variableFeePercentage'],
    };
}

export function CardSchemePriceOverrideToJSON(json: any): CardSchemePriceOverride {
    return CardSchemePriceOverrideToJSONTyped(json, false);
}

export function CardSchemePriceOverrideToJSONTyped(value?: CardSchemePriceOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cardScheme': CardSchemeToJSON(value['cardScheme']),
        'fixedFeeAmount': value['fixedFeeAmount'],
        'variableFeePercentage': value['variableFeePercentage'],
    };
}

